import { render, staticRenderFns } from "./Acompanhamento.vue?vue&type=template&id=06f37291&scoped=true&"
import script from "./Acompanhamento.vue?vue&type=script&lang=ts&"
export * from "./Acompanhamento.vue?vue&type=script&lang=ts&"
import style0 from "./Acompanhamento.vue?vue&type=style&index=0&id=06f37291&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f37291",
  null
  
)

export default component.exports